import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Intro.css';

class Intro extends Component {

  transformTextToHTML(text) {
    return text.replace(/\n/g, '<br/>');
  }

  render() {

    const {homepage} = this.props;

    return (
      <div className="Intro">
        {typeof homepage.homepageImage === "object" && (
          <img alt={homepage.title} src={homepage.homepageImage.url} />
        )}
        {homepage.homepageText && homepage.homepageText.length > 0 && (
          <blockquote dangerouslySetInnerHTML={{__html:this.transformTextToHTML(homepage.homepageText)}} />
        )}
      </div>
    );

  }

}

Intro.defaultProps = {
  homepage: {},
};

Intro.propTypes = {
  homepage: PropTypes.shape({
    homepageText: PropTypes.string,
    homepageImage: PropTypes.object,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default Intro;



// WEBPACK FOOTER //
// ./src/component/organisms/Intro/component.js